import type {FormFieldsAttributes} from '../types'

export const formFieldsEloqua: FormFieldsAttributes[] = [
  {
    label: 'Full Name',
    name: 'full_name',
    required: true,
    type: 'text',
  },
]

export const formFieldsMarketingFormsApi: FormFieldsAttributes[] = [
  {
    label: 'First Name',
    name: 'first_name',
    required: true,
    type: 'text',
  },
  {
    label: 'Last Name',
    name: 'last_name',
    required: true,
    type: 'text',
  },
]
